import React, { ReactElement, useContext, useState } from "react";
import { doNothing } from "../../Components/inputs/inputHelpers";
import { Dialog, FormControl, Grid, InputLabel, Select } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { YesNoControl } from "../../Components/YesNoControl";
import { LOCATION_MRU_DAYS_BACK_KEY, LOCATION_MRU_SHOW_KEY, TIME_ENTRY_STYLE_KEY } from "../../sharedCode/metadata";
import { GetTimeEntryStyle, MruDaysBack, ShowSuggestions } from "../../sharedCode/HelperMethods";
import NumberEditor from "../../Components/inputs/numberEditor";
import { GlobalContext } from "../../Utils/Contexts";
import MenuItem from "@mui/material/MenuItem";

export const TIME_ENTRY_STYLES = ["SPINNERS", "TEXT"];

export function UserPreferences(): ReactElement {
    const context = useContext(GlobalContext);
    const [updateUi, setUpdateUi] = useState(false);

    return (
        <Dialog open={true}>
            <Grid container sx={{ p: 2 }}>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Typography component="h1" variant="h6">
                        USER PREFERENCES
                    </Typography>
                </Grid>
                <Grid container item xs={12} sx={{ pt: 2 }}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel id="time-entry-style-label">TIME ENTRY STYLE</InputLabel>
                        <Select
                            fullWidth
                            labelId="time-entry-style-label"
                            value={GetTimeEntryStyle()}
                            label="TIME ENTRY STYLE"
                            onChange={(e) => handleEnterTimeAsTextChanged(e.target.value)}>
                            <MenuItem value={TIME_ENTRY_STYLES[0]}>{TIME_ENTRY_STYLES[0]}</MenuItem>
                            <MenuItem value={TIME_ENTRY_STYLES[1]}>{TIME_ENTRY_STYLES[1]}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container item xs={12} sx={{ pt: 2 }}>
                    <YesNoControl
                        sourceId={0}
                        sourceProperty={"NA"}
                        labelText="SHOW LOCATION/CC HINTS (MRU) ON FLIGHT LEGS?"
                        initialValue={ShowSuggestions()}
                        onChange={handleShowSuggestionsChanged}
                        mergeChanges={doNothing}
                        isDisabled={false}
                        isRequired={false}
                        errors={[]}
                        containerUrl={"userPreferences"}
                    />
                </Grid>
                <Grid container item xs={12} sx={{ pt: 2 }}>
                    <NumberEditor
                        sourceId={0}
                        sourceProperty={"daysBack"}
                        labelText="DAYS TO LOOK BACK WHEN BUILDING HINTS"
                        initialValue={MruDaysBack()}
                        mergeChanges={saveDaysBackValue}
                        isDisabled={false}
                        isRequired={true}
                        errors={[]}
                        containerUrl={"userPreferences"}
                        precision={0}
                    />
                </Grid>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Button variant="contained" sx={{ m: 1 }} onClick={handleClose}>
                        OK
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );

    function handleEnterTimeAsTextChanged(newStyle: string) {
        localStorage.setItem(TIME_ENTRY_STYLE_KEY, newStyle);
        setUpdateUi(!updateUi);
    }

    function handleShowSuggestionsChanged() {
        localStorage.setItem(LOCATION_MRU_SHOW_KEY, ShowSuggestions() ? "N" : "Y");
        setUpdateUi(!updateUi);
    }

    function saveDaysBackValue(id: number, changes: Record<string, unknown>) {
        const newValue = Number(changes["daysBack"]);
        localStorage.setItem(LOCATION_MRU_DAYS_BACK_KEY, newValue.toFixed(0));
    }

    function handleClose() {
        context.showUserPreferences(false);
    }
}
